import { InputBaseComponentsPropsOverrides, OutlinedInput, OutlinedInputProps, styled } from "@mui/material";
import React, { FC } from "react";
import { DayTimeInputProps } from "./types";
import { FormControlWrapper } from "@sinch/components";
import { DayTimeInputBase } from "@sinch/components/form/DayTimeInput/DayTimeInputBase";

export const DayTimeInput: FC<DayTimeInputProps> = ({
  label,
  FormHelperTextProps: formHelperTextProps,
  FormControlProps: formControlProps,
  helperText,
  errorMessage,
  error,
  required,
  infoTooltip,
  value,
  onChange,
  fullWidth,
  size,
  ...props
}) => (
  <FormControlWrapper
    error={error}
    errorMessage={errorMessage}
    FormHelperTextProps={formHelperTextProps}
    helperText={helperText}
    infoTooltip={infoTooltip}
    label={label}
    required={required}
    {...formControlProps}
    fullWidth={fullWidth}
  >
    <OutlinedWithTime
      disabled={props.disabled}
      error={error}
      onChange={onChange as unknown as OutlinedInputProps["onChange"]}
      readOnly={props.readOnly}
      size={size}
      slotProps={{
        input: {
          ...props,
          size: size,
          required,
        } as InputBaseComponentsPropsOverrides,
      }}
      slots={{
        input: DayTimeInputBase,
      }}
      value={value}
    />
  </FormControlWrapper>
);

const OutlinedWithTime = styled(OutlinedInput)<OutlinedInputProps>(({ theme }) => ({
  "& .MuiInputBase-input": {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));
